import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-M6LH746',
        },
    },
    host: 'www.zalando-lounge.cz',
});
